/* globals Trianglify */

'use strict';

angular.module('openDataApp')
  .directive('background', function () {
    return {
      restrict: 'E',
      scope: {
        color: '=color',
        width: '=width',
        height: '=height',
        cellSize: '=cellSize'
      },
      link: function($scope) {
        var pattern = new Trianglify({
          width: $scope.width || 3000,
          height: $scope.height || 3000,
          seed: 'siteworkers',
          cell_size: $scope.cellSize || 50,
          variance: "0.9",
          x_colors: ($scope.color !== undefined ? $scope.color.x : 'YlGnBu'),
          y_colors: ($scope.color !== undefined ? $scope.color.y : 'match_x')
        });
        document.querySelector('.bg:empty').appendChild(pattern.canvas());
      },
      template: '<div class="bg"></div>'
    };
  });
